<template>
    <div class="front-form">
      <div class="d-flex justify-center mb-8">
        <logo></logo>
      </div>
        <div class="front-form__wrap">
            <v-card class="elevation-12 front-form__block">
                <v-toolbar dark color="primary login__logotype">
                    <v-toolbar-title>{{ $t('msg.registration') }}</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-form>
                        <!--<v-text-field
                                prepend-icon="mdi-account"
                                name="login"
                                :label="$t('msg.loginName')"
                                v-model="model.login"
                                v-validate="'required|char_name'"
                                :error-messages="errors.collect('login')"
                                @keyup.enter="onSubmit()"
                                outlined
                                dense
                                hide-details="auto"
                                class="mt-1"
                                autocomplete="off"
                        ></v-text-field>-->
                        <v-text-field
                                prepend-icon="mdi-email"
                                name="email"
                                label="Email"
                                type="email"
                                v-model="model.email"
                                v-validate="'required|email'"
                                :error-messages="errors.collect('email')"
                                @keyup.enter="onSubmit()"
                                outlined
                                dense
                                hide-details="auto"
                                class="mt-4"
                                autocomplete="off"
                                ref="email"
                        ></v-text-field>
                        <v-text-field
                                prepend-icon="mdi-lock"
                                name="password"
                                :label="$t('msg.password')"
                                type="password"
                                v-model="model.password"
                                v-validate="'required|min:6|max:255'"
                                :error-messages="errors.collect('password')"
                                @keyup.enter="onSubmit()"
                                ref="first_password"
                                outlined
                                dense
                                hide-details="auto"
                                class="mt-4"
                                autocomplete="off"
                        ></v-text-field>
                        <!--<v-text-field
                                prepend-icon="mdi-lock"
                                name="repeat_password"
                                :label="$t('msg.repeatPassword')"
                                type="password"
                                v-model="model.repeat_password"
                                v-validate="'required|repeat_password:first_password'"
                                :error-messages="errors.collect('repeat_password')"
                                @keyup.enter="onSubmit()"
                                outlined
                                dense
                                hide-details="auto"
                                class="mt-4"
                        ></v-text-field>-->
                        <!--<v-select
                                v-model="model.lang"
                                :label="$t('msg.language')"
                                outlined
                                dense
                                hide-details="auto"
                                :items="$store.state.common.langs"
                                item-text="name"
                                item-value="code"
                                class="mt-4"
                                prepend-icon="mdi-web"
                                @change="changeLang($event)"
                        ></v-select>-->
                    </v-form>
                </v-card-text>
                <v-card-actions class="pt-3 pl-4 pr-4">
                  <c-btn
                    color="primary"
                    @click="onSubmit"
                    :disabled="loading"
                    :loading="loading"
                    class="mr-2 mb-3"
                    width="100%"
                    mobile
                  >{{ $t('msg.login') }}</c-btn>
                </v-card-actions>
            </v-card>
        </div>
        <div class="front-form__links">
            <c-btn
              :to="{name: 'login', query: {email: model.email}}"
              color="secondary"
            >{{ $t('msg.loginAuth') }}</c-btn>
        </div>
      <div class="d-flex justify-center mt-12">
        <support
          style="width: 400px;"
          :msg="$t('msg.errorLoginToSupport')"
        ></support>
      </div>
    </div>
</template>

<script>
import CBtn from "@/components/ui/CBtn";
import Support from "@/components/block/Support";
import Logo from "@/components/block/Logo";

    export default {
        components: {CBtn, Support, Logo},
        data () {
            return {
                loading: false,
                model: {
                    login: null,
                    email: null,
                    password: null,
                    repeat_password: null,
                    lang: this.$store.state.user.lang,
                    tz: this.$store.state.user.timeZone,
                    utm: this.$store.state.common.utm,
                }
            }
        },
        methods: {
            onSubmit () {
                this.$validator.validateAll()
                    .then(res => {
                        if (res) {
                            this.loading = true;

                            this.$store.dispatch('registrationUser', {
                                data: this.model,
                                formErrors: this.$validator.errors
                            })
                                .then(() => {
                                    // this.showSnackBar();
                                    this.$store.commit('setLogin', 'true');
                                    this.$router.push({name: 'diary'});
                                    this.$socket.connecting();

                                    this.eventRegStart();
                                })
                                .finally(() => this.loading = false);
                        } else {
                            this.scrollToError(this.$validator.errors);
                        }
                    });
            },
            showSnackBar() {

              let msg = '<div class="snack-bar__title">'+this.$t('msg.youHaveSuccessfullyRegistered')+'</div>'
              msg += this.$t('msg.loginLinkHasBeenSentTo') + ': <b>' + this.model.email + '</b>';

              if (typeof this.model.email === 'string') {
                let pos = this.model.email.indexOf('@');
                let domain = this.model.email.substring(pos+1);

                let link = '';

                if (domain === 'mail.ru' || domain === 'internet.ru' || domain === 'bk.ru' || domain === 'inbox.ru' ||
                  domain === 'list.ru') {
                  link = 'https://e.mail.ru/';
                } else if (domain === 'yandex.ru') {
                  link = 'https://mail.yandex.ru/';
                } else if (domain === 'gmail.com') {
                  link = 'https://mail.google.com/';
                }

                if (link.length > 0) {
                  msg += '<a href="'+link+'" style="display: block; margin-top: 15px; color: #fff;" target="_blank">'+this.$t('msg.openMail')+'</a>'
                }
              }

              this.$store.commit('setSnackBar', {
                msgRaw: msg,
                timeout: 60000 * 10,
              });
            },
            changeLang(lang) {
                this.$store.commit('setLang', lang);
                this.$i18n.locale = lang;
            },
            eventRegStart() {
              if (process.env.NODE_ENV !== 'development') {
                ym(92218980,'reachGoal','reg');
              }
            }
        },
      mounted() {
        // this.showSnackBar();
        // console.log(this.$route.query)
        if (this.$route.query.email !== undefined) {
          this.model.email = this.$route.query.email;
        }

        this.$nextTick(() => {
          this.$refs.email.focus();
        });
      },
    }
</script>

<style lang="scss">
    .login__logotype {
        .v-toolbar__content {
            display: flex;
            justify-content: center;
        }
    }
</style>
